import { render, staticRenderFns } from "./CaricaFile.vue?vue&type=template&id=66f1951a"
import script from "./CaricaFile.vue?vue&type=script&lang=js"
export * from "./CaricaFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports